import { render, staticRenderFns } from "./LayoutCompareNote.vue?vue&type=template&id=543f23c2"
import script from "./LayoutCompareNote.vue?vue&type=script&lang=js"
export * from "./LayoutCompareNote.vue?vue&type=script&lang=js"
import style0 from "./LayoutCompareNote.vue?vue&type=style&index=0&id=543f23c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports